import React, { useState } from "react"
import valuer_api from "../../../api/valuer"
import cloud from "../../../assets/upload_cloud.png"

const UploadYamlTemplate = ({ onSuccess }) => {
    const [fileName, setFileName] = useState("")           // without .yaml/.yml
    const [fullFileName, setFullFileName] = useState("")   // with extension
    const [yamlContent, setYamlContent] = useState("")
    const [error, setError] = useState("")

    const handleFile = (file) => {
        const match = file.name.match(/^(.*)\.(yaml|yml)$/i)
        if (!match) {
            setError("Only .yaml or .yml files allowed")
            return
        }

        const baseName = match[1]
        setFileName(baseName)
        setFullFileName(file.name)

        const reader = new FileReader()
        reader.onload = (e) => {
            setYamlContent(e.target.result)
            setError("")
        }
        reader.readAsText(file)
    }

    const handleDrop = (e) => {
        e.preventDefault()
        const file = e.dataTransfer.files[0]
        if (file) handleFile(file)
    }

    const handleChange = (e) => {
        const file = e.target.files[0]
        if (file) handleFile(file)
    }

    const saveTemplate = async () => {
        if (!fileName || !yamlContent) {
            setError("Missing name or file content")
            return
        }

        try {
            await valuer_api.uploadYamlTemplate({
                name: fileName,
                yaml_content: yamlContent
            })
            onSuccess?.()
            setFileName("")
            setFullFileName("")
            setYamlContent("")
            setError("")
        } catch (err) {
            setError("Upload failed. Please try again.")
        }
    }

    return (
        <>
            <div className="upload-yaml-template-outer">
                {/* Drag and drop box */}
                <div
                    className="upload-yaml-template-drag-and-drop"
                    onDrop={handleDrop}
                    onDragOver={(e) => e.preventDefault()}
                    onClick={() => document.getElementById("yaml-upload").click()}
                >
                    <img src={cloud} alt="upload" />
                    <span style={{ color: "#fff" }}>
            {fullFileName || "Drag and Drop or click to Upload"}
        </span>
                    <input
                        id="yaml-upload"
                        type="file"
                        accept=".yaml,.yml"
                        onChange={handleChange}
                        hidden
                    />
                </div>

                <button
                    onClick={saveTemplate}
                    disabled={!yamlContent || !fileName}
                    className="upload-yaml-template-button"
                >
                    Save PDF
                </button>
            </div>

            {error && <p style={{ color: "red", marginTop: "8px" }}>{error}</p>}
        </>
    )
}

export default UploadYamlTemplate
